import { useEffect } from "react";
import { ClientAuthProvider, useClientAuth } from "./lib/auth-context";
import { ClientRouter, useClientRouter } from "./lib/router-context";
import { ClientLayout } from "./components/ClientLayout";
import LoginPage from "./pages/LoginPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import DashboardPage from "./pages/DashboardPage";
import ActivationPage from "./pages/ActivationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SocietePage from "./pages/SocietePage";
import { Loader2 } from "lucide-react";

function NotFound() {
  const { navigate } = useClientRouter();
  return (
    <div className="flex items-center justify-center h-full min-h-[60vh] flex-col gap-4">
      <p className="text-2xl font-bold text-foreground">Page introuvable</p>
      <button onClick={() => navigate("/")} className="text-primary hover:underline text-sm">Retour au tableau de bord</button>
    </div>
  );
}

function renderPage(path: string) {
  if (path === "/" || path === "") return <DashboardPage />;
  if (path === "/societe") return <SocietePage />;
  return <NotFound />;
}

const AUTH_ONLY_PATHS = ["/login", "/connexion"];

function AppRouter() {
  const { isAuthenticated, isLoading, user } = useClientAuth();
  const { path, navigate } = useClientRouter();

  useEffect(() => {
    if (isAuthenticated && AUTH_ONLY_PATHS.includes(path)) {
      navigate("/");
    }
  }, [isAuthenticated, path, navigate]);

  if (path === "/activation") return <ActivationPage />;
  if (path === "/reinitialisation") return <ResetPasswordPage />;
  if (path === "/mot-de-passe-oublie") return <ForgotPasswordPage />;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (user?.mustChangePassword && path !== "/change-password") {
    navigate("/change-password");
    return null;
  }

  if (path === "/change-password") {
    return <ChangePasswordPage />;
  }

  return (
    <ClientLayout>
      {renderPage(path)}
    </ClientLayout>
  );
}

export default function App() {
  return (
    <ClientRouter>
      <ClientAuthProvider>
        <AppRouter />
      </ClientAuthProvider>
    </ClientRouter>
  );
}
